import { render, staticRenderFns } from "./ChangePhoneDialog.vue?vue&type=template&id=fa34fff8&scoped=true"
import script from "./ChangePhoneDialog.vue?vue&type=script&lang=ts"
export * from "./ChangePhoneDialog.vue?vue&type=script&lang=ts"
import style0 from "./ChangePhoneDialog.vue?vue&type=style&index=0&id=fa34fff8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa34fff8",
  null
  
)

export default component.exports